import * as yup from 'yup';

import { DEFAULT_VALUE, trendFileInputSchema } from 'features/trends/components/molecules/TrendFileInput/config';
import { Value } from 'features/users/components/organisms/TagsInput';
import { TAG_CATEGORIES } from 'features/users/components/organisms/TagsInput/types';

import { Trend } from 'shared/typings/trends';

export const initialValues: TrendFormValues = {
  name: '',
  tags: [{ category: TAG_CATEGORIES.INDUSTRY, values: [] }],
  file: DEFAULT_VALUE,
};

export const getValidationSchema = (trendNames: Pick<Trend, 'id' | 'name'>[], trendId?: number) =>
  yup.object({
    name: yup
      .string()
      .customRequiredString()
      .test({
        name: 'unique',
        message: 'Trend name must be unique',
        test(val) {
          // if a new trend then check all names
          if (!trendId) return !trendNames.find(({ name }) => name === val);
          // otherwise exclude the current trend name from the check
          return !trendNames.find(({ name, id }) => id !== trendId && name === val);
        },
      }),
    tags: yup.array().of(
      yup.object({
        category: yup.string().oneOf(['industry']).required('Category is required'),
        values: yup.array().of(yup.string().required()).max(1, 'Only one tag is allowed'),
      }),
    ),
    file: trendFileInputSchema,
  });

export interface TrendFormValues {
  name: string;
  tags: Value[];
  file: {
    id: number;
    name: string;
  };
}
